import { CalloutBlock } from "@bezoned/shared/components/callout-block.jsx";

export const RetryAdminPermissions = ({ onRetry }: { onRetry: () => void }) => (
  <div className="flex min-h-screen items-center justify-center bg-gray-100">
    <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
      <h1 className="mb-4 text-2xl font-bold text-gray-900">
        Permissions Required
      </h1>

      <CalloutBlock variant="error">
        <p>
          Required permissions were not granted. You may try it again or ask
          your IT administrator to grant the consent for you.
        </p>
      </CalloutBlock>

      <button
        className="bg-bzd-button hover:bg-bzd-button-hover mt-4 block w-full rounded-md px-4 py-2 text-center text-white transition-colors"
        onClick={onRetry}
        type="button"
      >
        Retry
      </button>
    </div>
  </div>
);
